import { Box, CircularProgress } from "@mui/material";
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import useAuth from "../../contexts/AuthContext";

function SeamlessLogin() {
	const auth = useAuth();
	const navigate = useNavigate();
	
	const [queryParams] = useSearchParams();

	useEffect(() => {
		async function performSeamlessLogin() {
			const token = queryParams.get("token");
			if (!token) {
				navigate("/login", { replace: true });
				return;
			}

			try {
				const success = await auth.loginWithToken(token);
				if (!success) {
					navigate("/login", { replace: true });
					return;
				}

				const redirectUrl = queryParams.get("redirect");
				navigate(redirectUrl ?? "/accounts", { replace: true });
			} catch {
				navigate("/login", { replace: true });
			}
		}

		performSeamlessLogin();
	}, []);

	return (
		<Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", width: "100vw" }}>
			<Box>
				<CircularProgress />
			</Box>
		</Box>
	);
}

export default SeamlessLogin;
